module.exports = __webpack_public_path__ + "img/Ilustration-download-motion-bank.52569196.png";